import {
  faArrowRightArrowLeft,
  faCartShopping,
  faGavel,
} from '@fortawesome/pro-solid-svg-icons';
import { Outlet } from 'react-router';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import {
  MY_SORARE_PURCHASES_AUCTIONS,
  MY_SORARE_PURCHASES_INSTANT_BUYS,
  MY_SORARE_PURCHASES_MANAGER_SALES,
} from '@sorare/core/src/constants/__generated__/routes';

import { MySorareSubTabsLayout } from '@sorare/marketplace/src/components/mySorare/MySorareSubTabsLayout';
import { TITLES } from '@sorare/marketplace/src/components/mySorare/common/pages';

const tabsValues = [
  {
    to: MY_SORARE_PURCHASES_AUCTIONS,
    label: TITLES.auctions,
    icon: <FontAwesomeIcon color="var(--c-onBase-success)" icon={faGavel} />,
  },
  {
    to: MY_SORARE_PURCHASES_INSTANT_BUYS,
    label: TITLES.primary_offers,
    icon: <FontAwesomeIcon color="var(--c-blue-400)" icon={faCartShopping} />,
  },
  {
    to: MY_SORARE_PURCHASES_MANAGER_SALES,
    label: TITLES.purchases,
    icon: (
      <FontAwesomeIcon
        color="var(--c-green-400)"
        icon={faArrowRightArrowLeft}
      />
    ),
  },
];

const MySorareOffersLayout = () => {
  return (
    <MySorareSubTabsLayout tabs={tabsValues}>
      <Outlet />
    </MySorareSubTabsLayout>
  );
};
export default MySorareOffersLayout;
